import React, { useTransition } from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Circle,
  Svg,
  Line,
} from "@react-pdf/renderer";
import { useTranslation } from "react-i18next";

const paddingVertical = 10;
// Create styles
const styles = StyleSheet.create({
  page: {
    textAlign: "center",
    paddingLeft: 80,
    paddingRight: 80,
    paddingTop: 40,
    paddingBottom: 40,
  },
  section: {
    backgroundColor: "#f2f9fe",
    color: "#2196F2",
  },
  title: {
    paddingTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    fontSize: 18,
  },
  imageDownload: {
    paddingVertical: paddingVertical,
    margin: "auto",
    width: 300,
    height: 160,
  },
  imagePhone: {
    paddingVertical: paddingVertical,
    margin: "auto",
    width: 150,
    height: 160,
  },
  description: {
    fontSize: 13,
    paddingLeft: 20,
    paddingRight: 20,
  },
  space: {
    padding: paddingVertical,
  },
});

// Create Document Component
export default function InstructionPage({ accountSettings }) {
  const { t } = useTranslation();
  const steps = [
    {
      id: "download",
      description: t("setup.manual.download"),
      image: "set-up-app-0.png",
    },
    {
      id: "nickname",
      description: t("setup.manual.nickname"),
      image: "set-up-app-1.png",
    },
    {
      id: "terms",
      description: t("setup.manual.terms"),
      image: "set-up-app-2.png",
    },
    {
      id: "recovery",
      description: t("setup.manual.recovery"),
      image: "",
    },
    {
      id: "add",
      description: accountSettings.findOnName
        ? `${t("setup.manual.searchOnName", {
            name: accountSettings.lastName,
            code: accountSettings.code,
          })} ${t("setup.manual.pressToConfirm")}`
        : `${t("setup.manual.searchOnCode", {
            name: accountSettings.lastName,
            code: accountSettings.code,
          })} ${t("setup.manual.pressToConfirm")}`,
      image: "set-up-app-3.png",
    },
  ];
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.title}>
            {t("setup.manual.title", {
              firstName: accountSettings.firstName,
              lastName: accountSettings.lastName,
            })}
          </Text>
          <Text style={styles.space} />
        </View>
        {steps.map((step, index) => (
          <View key={step.id} style={styles.section}>
            <Svg viewBox="0 0 100 8">
              <Line
                x1="0"
                y1="4"
                x2="100"
                y2="4"
                stroke="#2196F2"
                strokeWidth="0.3"
                strokeDasharray="1"
              />
              <Circle
                cx="50"
                cy="4"
                r="3"
                fill="white"
                stroke="#2196F2"
                strokeWidth="0.4"
              />
              <Text x="49" y="5.5" fill="#2196F2" style={{ fontSize: 4 }}>
                {index + 1}
              </Text>
            </Svg>
            {step.image !== "" ? (
              <Image
                style={
                  step.id === "download"
                    ? styles.imageDownload
                    : styles.imagePhone
                }
                src={`${window.REACT_APP_IMAGE_PATH}/setup/${step.image}`}
              />
            ) : null}
            <Text style={styles.description}>{step.description}</Text>
            <Text style={styles.space} />
          </View>
        ))}
        <View style={styles.section}>
          <Text style={styles.description}>{t("setup.manual.later")}</Text>
          <Image
            style={styles.imagePhone}
            src={`${window.REACT_APP_IMAGE_PATH}/setup/set-up-app-4.png`}
          />
          <Text style={{ padding: 2 * paddingVertical }} />
        </View>
      </Page>
    </Document>
  );
}
